module.exports = __webpack_public_path__ + "img/vip-banner-bg.f90233a4.png";